import { Licenses } from "../License";
import { SchoolLicenses } from "../License/SchoolLicenses";

/**
 * @typedef {"school" | "organization"} TenantType
 */

/**
 * LicensesPage - Settings page content for Licenses management
 * Renders inside SettingsLayout via Outlet
 * Uses SchoolLicenses for school type and Licenses for organization type
 *
 * @param {{ type?: TenantType }} props
 */

const LicensesPage = ({ type = "school" }) => {
  // Use school-specific component for schools, organization component for organizations
  if (type === "school") {
    return <SchoolLicenses />;
  }

  return <Licenses type={type} />;
};

export default LicensesPage;
